import React, { useState } from 'react';

export default function VoucherRedeemModal({ voucher, busy, onClose, onConfirm }) {
  const [hours, setHours] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const nextHours = Number(hours);
    setError('');

    if (nextHours <= 0) {
      setError('Introduce una cantidad válida.');
      return;
    }

    if (nextHours > voucher.hoursAvailable) {
      setError('No hay horas disponibles suficientes para realizar ese canje.');
      return;
    }

    const success = await onConfirm(nextHours);

    if (!success) {
      setError('No se pudo realizar el canje.');
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(17,24,39,0.24)] backdrop-blur-md p-4">
      <div className="w-full max-w-xl rounded-[30px] border border-white/80 bg-[rgba(255,255,255,0.94)] shadow-[0_30px_90px_rgba(15,23,42,0.18)]">
        <div className="flex items-center justify-between border-b border-[var(--app-border)] px-6 py-5">
          <div>
            <p className="text-[11px] uppercase tracking-[0.24em] text-slate-400">Canjear bono</p>
            <h3 className="mt-2 text-2xl font-semibold text-slate-950">{voucher.voucherCode}</h3>
            <p className="mt-1 text-sm text-slate-500">{voucher.hoursAvailable}h disponibles</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-2xl border border-[var(--app-border)] bg-[rgba(245,245,247,0.9)] px-4 py-2 font-medium"
          >
            Cerrar
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5 p-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-slate-700">Horas a descontar</label>
            <input
              type="number"
              min="1"
              step="1"
              value={hours}
              onChange={(event) => {
                setHours(event.target.value);
                if (error) {
                  setError('');
                }
              }}
              placeholder="Ej: 2"
              className="w-full rounded-[22px] border border-[var(--app-border)] bg-white px-5 py-4 text-3xl font-semibold tracking-[-0.03em] text-slate-950"
            />
          </div>

          {error && (
            <p className="text-sm font-medium text-red-600">{error}</p>
          )}

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-[20px] bg-[rgba(245,245,247,0.9)] px-5 py-3 font-medium text-slate-700"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={busy}
              className="rounded-[20px] bg-[#0a84ff] hover:bg-[#0077ed] px-5 py-3 font-semibold text-white disabled:opacity-60"
            >
              {busy ? 'Canjeando...' : 'Confirmar canje'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
